import React, { useState, useEffect, lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import CheckIn from "./CheckIn";
import CheckOut from "./CheckOut";
import AttendanceServices from "../../../services/AttendanceServices";
import Swal from "sweetalert2";
const MivModal = lazy(() => import("../Vehicle/MivModal"));


const CheckInOutNew = () => {
  const [open, setOpen] = useState(true);
  const [showCheckInModal, setShowCheckInModal] = useState(false);
  const [showCheckOutModal, setShowCheckOutModal] = useState(false);
  const [loading, setLoading] = useState(false);

  // Handlers for modals
  const [showCheckIn, setShowCheckIn] = useState(false);
  const [showCheckOut, setShowCheckOut] = useState(false);
  const [showMivModal, setShowMivModal] = useState(false);
  const [data, setData] = useState([]);
  const [selectedAttendance, setSelectedAttendance] = useState(null);
  const [run, setRun] = useState(0)

  useEffect(() => {
    setLoading(true); // ✅ START

    AttendanceServices.myAttendance()
      .then((res) => {
        const apiData = res?.data || [];
        setData(apiData);
      })
      .catch((error) => {
        const msg = error?.response?.data?.message;

        if (msg === "No attendance records found for this driver.") {
          setData([]);
          return;
        }

        Swal.fire({
          icon: "error",
          title: "Error",
          text: msg || "Something went wrong!",
        });
      })
      .finally(() => {
        setLoading(false); // ✅ STOP
      });
  }, [run]);

  const formatDate = (isoString) => {
    if (!isoString) return "N/A"; // Handle undefined/null values

    const date = new Date(isoString);
    if (isNaN(date.getTime())) return "N/A"; // Handle invalid date values

    // Extract date parts using `toLocaleString`
    const day = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", day: "2-digit" });
    const month = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", month: "2-digit" });
    const year = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", year: "numeric" });
    const hours = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", hour: "2-digit", hour12: false });
    const minutes = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", minute: "2-digit" });
    const seconds = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", second: "2-digit" });

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <>
      <CheckIn show={showCheckIn} handleClose={() => setShowCheckIn(false)} onSuccess={() => setRun(run + 1)} />
      <CheckOut show={showCheckOut} handleClose={() => setShowCheckOut(false)} onSuccess={() => setRun(run + 1)} />
      <Suspense
        fallback={
          <div className="text-center p-3">
            <div className="spinner-border text-primary" />
            <div>Loading Diesel Module...</div>
          </div>
        }
      >
        {showMivModal && (
          <Suspense
            fallback={
              <div className="text-center p-3">
                <div className="spinner-border text-primary" />
                <div>Loading Diesel Module...</div>
              </div>
            }
          >
            <MivModal
              show={showMivModal}
              attendance={selectedAttendance}
              handleClose={() => {

                setShowMivModal(false);
                setSelectedAttendance(null);

              }}
              onSuccess={() => setRun(run + 1)}
            />
          </Suspense>
        )}
      </Suspense>
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa">
                <i className="fa fa-plus me-2" aria-hidden="true"></i>Check In / Check Out
              </div>
              <div className="tools">
                <button
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                  aria-label="Toggle Collapse"
                  style={{ background: "none", border: "none", cursor: "pointer" }}
                >
                  <i className="fas fa-angle-up"></i>
                </button>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <button
                        className="btn btn-primary w-100"
                        onClick={() => setShowCheckIn(true)}
                      >
                        Check In (चेक इन करें)
                      </button>
                    </div>
                    <div className="col-md-6">
                      <button
                        className="btn btn-success w-100"

                        onClick={() => setShowCheckOut(true)}
                      >
                        Check Out (चेक आउट करें)
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa">
                <i className="fa fa-plus me-2" aria-hidden="true"></i>Check In / Check Out last 5 Enteries (चेकइन दिनांक/समय - अंतिम 5 प्रविष्टियाँ)
              </div>
              <div className="tools">
                <button
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                  aria-label="Toggle Collapse"
                  style={{ background: "none", border: "none", cursor: "pointer" }}
                >
                  <i className="fas fa-angle-up"></i>
                </button>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="po-table-wrapper">
                    <div style={{
                      overflowX: 'auto',
                      overflowY: 'auto',
                      maxHeight: '400px',
                      whiteSpace: 'nowrap'
                    }}>
                      <table
                        className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                        id="transactions-data"
                      >
                        <thead
                          style={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "#fff",
                            zIndex: 2,
                          }}
                        >
                          <tr>
                            <th>#</th>
                            <th>Issue Diesel</th>
                            <th>Status</th>
                            <th>Machine</th>
                            <th>Operator</th>
                            <th>Store</th>
                            <th>Date</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Start HMR</th>
                            <th>End HMR</th>
                            <th>Diesel</th>
                          </tr>
                        </thead>

                        <tbody>
                          {loading ? (
                            <tr>
                              <td
                                colSpan="12"
                                className="text-center text-danger fw-bold"
                              >
                                <div className="spinner-border text-primary"></div>
                                <div className="mt-2 text-muted">
                                  Loading data...
                                </div>
                              </td>
                            </tr>
                          ) : data.length === 0 ? (
                            <tr>
                              <td
                                colSpan="12"
                                className="text-center text-danger fw-bold"
                              >
                                No Record Found
                              </td>
                            </tr>
                          ) : (
                            data.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>

                                <td>
                                  {item.status === "checkIn" ? (
                                    <button
                                      className="btn btn-success btn-sm"
                                      onClick={() => {
                                        setSelectedAttendance(item);
                                        setShowMivModal(true);
                                      }}
                                    >
                                      Issue Diesel
                                      <br />
                                      डीजल जारी करें
                                    </button>
                                  ) : (
                                    <span className="badge bg-secondary">
                                      Completed
                                      <br />
                                      डीजल जारी नहीं कर सकते
                                    </span>
                                  )}
                                </td>

                                <td>
                                  <span
                                    className={`badge ${item.status === "checkIn"
                                      ? "bg-warning text-dark"
                                      : "bg-success"
                                      }`}
                                  >
                                    {item.status === "checkIn"
                                      ? "Running"
                                      : "Completed"}
                                  </span>
                                </td>

                                <td>
                                  <strong>
                                    {item.vehicleName || "N/A"}
                                  </strong>

                                  <br />

                                  <small className="text-muted">
                                    {item.equipmentNo || ""}
                                  </small>
                                </td>

                                <td>
                                  {item.driverName || "N/A"}
                                </td>

                                <td>
                                  {item.attendanceStore ||
                                    item.vehicleStore ||
                                    "N/A"}
                                </td>

                                <td>
                                  {formatDate(item.createdAt)}
                                </td>

                                <td>
                                  {formatDate(item.startTime)}
                                </td>

                                <td>
                                  {item.endTime ? (
                                    formatDate(item.endTime)
                                  ) : (
                                    <span className="text-warning fw-bold">
                                      Running
                                    </span>
                                  )}
                                </td>

                                <td>
                                  {item.startKM} HMR
                                </td>

                                <td>
                                  {item.endKM ? (
                                    `${item.endKM} HMR`
                                  ) : (
                                    <span className="text-info">
                                      Not Closed
                                    </span>
                                  )}
                                </td>



                                <td>
                                  {item.desile?.length > 0 ? (
                                    <>
                                      <span className="badge bg-primary">
                                        {item.desile.length} Fill
                                      </span>

                                      <div
                                        style={{
                                          fontSize: "12px",
                                        }}
                                      >
                                        {item.desile.map(
                                          (d, i) => (
                                            <div key={i}>
                                              ⛽{" "}
                                              {d.dieselInReading}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </>
                                  ) : (
                                    <span className="text-muted">
                                      No Diesel
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>


                </div>


              </div>
            </Collapse>
          </div>
        </div>
      </div>

    </>
  );
};

export default CheckInOutNew;
